import { Component, OnInit, AfterContentInit, OnDestroy, Renderer2 } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { GoogleAnalyticsService } from "./services/google-analytics.service";
import { ChatService } from "./services/chat.service";
import { CanonicalUrlService } from "./meta/services/canonical-url.service";
import { SegmentAnalyticsService } from "./services/segment-analytics.service";
import { LocaleService } from "./services/locale.service";
import { HCaptchaService } from "./services/hcaptcha.service";
import { AmplitudeAnalyticsService } from "./services/amplitude-analytics.service";
import { MessagingService } from "./services/messaging.service";
import { ClevertapTrackingService } from "./services/clevertap-tracking.service";
import { ABTestingService } from "./services/abtesting.service";
import { ThemeService } from "./services/theme.service";
import { AuthService } from "./api/auth.service";
import { Subscription } from "rxjs";
import { SEOService } from "./services/seo.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit, AfterContentInit, OnDestroy {
  title = "push-notification";
  message;

  routeParamsSubscription: Subscription;

  constructor(
    private router: Router,
    private ga: GoogleAnalyticsService,
    private chatService: ChatService,
    private canonicalUrlService: CanonicalUrlService,
    private segmentAnalyticsService: SegmentAnalyticsService,
    private hCaptchaService: HCaptchaService,
    private localeService: LocaleService,
    private messagingService: MessagingService,
    private amplitudeAnalyticsService: AmplitudeAnalyticsService,
    private clevertapTrackingService: ClevertapTrackingService,
    private aBTestingService: ABTestingService,
    private auth: AuthService,
    private themeService: ThemeService,
    private seoService: SEOService,
    private renderer:Renderer2
  ) {}

  ngOnInit() {
    //add schema depending on language
    this.seoService.addSchema(this.renderer);
    // Hreflang Links
    this.seoService.initHreflang();
    
    // Chat
    this.chatService.init();

    // Canonical Urls
    this.canonicalUrlService.init();

    // Google Analytics
    this.ga.init();

    // Segment SDK
    this.segmentAnalyticsService.init();

    // Amplitude SDK
    this.amplitudeAnalyticsService.init();

    // A/B Testing
    this.aBTestingService.init();

    // captcha
    this.hCaptchaService.init();

    // Clevertap
    this.clevertapTrackingService.init();

    // RTL
    if (this.localeService.isArabic()) {
      const body = document.getElementsByTagName("body")[0];
      body.classList.add("rtl");
      // Adding this to enalbe rtl support in ng-material components eg: mat-checkbox
      body.setAttribute("dir", "rtl");
    }

    if (this.isLoggedIn() && Notification.permission === "granted") {
      this.messagingService.requestPermission();
      this.messagingService.receiveMessage();
      this.message = this.messagingService.currentMessage;
    }

    // Theme
    // TODO: Uncomment this once we have a design for implementing dark mode across all pages.
    // this.themeService.init();
  }

  ngAfterContentInit() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Scroll
        window.scroll(0, 0);
        window.document.body.classList.remove("noscroll");
        window.document.body.classList.remove("noscroll-mobile");

        // TODO: This placeholder is temporary and should be removed once a comprehensive dark mode design is available for all pages.
        this.themeService.reset();
      });
  }

  ngOnDestroy() {
    this.hCaptchaService.remove();
    this.routeParamsSubscription?.unsubscribe();
  }

  isLoggedIn() {
    return this.auth.getToken();
  }
}
